import { render } from "./SelectState.vue?vue&type=template&id=23525c0a"
import script from "./SelectState.vue?vue&type=script&lang=js"
export * from "./SelectState.vue?vue&type=script&lang=js"
script.render = render

export default script